import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Input,
    Checkbox,
    Stack,
    Text,
    FormControl,
    FormErrorMessage,
    Flex,
} from "@chakra-ui/react";
import { useState } from "react";
import EventsService from '../../api/services/EventsService';
import {useTranslation} from "react-i18next";
import {useAppToast} from "../../hooks/useAppToast";

const RegistrationModal = ({ isOpen, onClose, onSuccess, onOverlap, event }) => {
    const {t} = useTranslation("default");

    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [accepted, setAccepted] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const toast = useAppToast();

    // Walidacja
    const isNameValid = name.trim().length > 2;
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    const isAccepted = accepted;
    const isFormValid = isNameValid && isEmailValid && isAccepted;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid) return;

        setSubmitting(true);

        try {
            const response = await EventsService.register(event.id, name, email);

            if (!response.data.isSuccess) {
                if(response.data?.code == 'Error.EventOverlapping') {
                    onClose();
                    onOverlap();
                    setSubmitting(false);
                    return;
                }else{
                    throw new Error(response?.date?.message);
                }
            }
            event.maxParticipants -=1;
            setSubmitting(false);
            onSuccess();
        } catch (error) {
            if(error.response.data?.code == 'Error.EventOverlapping') {
                onClose();
                onOverlap();
                setSubmitting(false);
                return;
            }else {
                console.error(error);
                toast({
                    title: t('error'),
                    description: error.response?.data?.message ?? t('ticker.save.error'),
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
                setSubmitting(false);
            }
        }
    };

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
            <ModalOverlay />
            <ModalContent p={{base: '16px', md: '48px'}} gap={'48px'}>
                <ModalHeader>
                    <Flex flexDirection={"column"} gap={'16px'}>
                        <Text fontFamily="body" fontWeight={'700'} fontSize={'24px'} lineHeight={'100%'} color={'#1E1517'}>
                            {t('event.save')}
                        </Text>
                        <Text fontFamily="body" fontWeight={'400'} fontSize={'16px'} lineHeight={'100%'} color={'#1E1517'}>
                            {event.title}
                        </Text>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton mt={'45px'} mr={'45px'} size={"lg"}/>
                <form onSubmit={handleSubmit}>
                    <ModalBody>
                        <Stack spacing={4}>
                            <FormControl isInvalid={!isNameValid && name.length > 0}>
                                <Text fontFamily="body" fontWeight={'400'} fontSize={'16px'} lineHeight={'150%'} color={'#1E1517'}>
                                    {t('user.name')}
                                </Text>
                                <Input
                                    bgColor={'#F8F5F4'} border={0} borderRadius={'12px'}
                                    placeholder=""
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    isRequired
                                />
                                {!isNameValid && name.length > 0 && (
                                    <FormErrorMessage>{t('required.user.name')}</FormErrorMessage>
                                )}
                            </FormControl>

                            <FormControl isInvalid={!isEmailValid && email.length > 0}>
                                <Text fontFamily="body" fontWeight={'400'} fontSize={'16px'} lineHeight={'150%'} color={'#1E1517'}>
                                    {t('user.email')}
                                </Text>
                                <Input
                                    bgColor={'#F8F5F4'} border={0} borderRadius={'12px'}
                                    placeholder=""
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    isRequired
                                />
                                {!isEmailValid && email.length > 0 && (
                                    <FormErrorMessage>{t('required.user.email')}</FormErrorMessage>
                                )}
                            </FormControl>

                            <FormControl isInvalid={!isAccepted && accepted === false}>
                                <Checkbox
                                    isChecked={accepted}
                                    onChange={(e) => setAccepted(e.target.checked)}
                                >
                                    <Text fontFamily="body" fontWeight={'400'} fontSize={'14px'} lineHeight={'150%'} color={'#1E1517'}>
                                        {t('consent.message')}
                                    </Text>
                                </Checkbox>
                                {!isAccepted && (
                                    <FormErrorMessage>{t('consent.error.message')}</FormErrorMessage>
                                )}
                            </FormControl>
                        </Stack>
                    </ModalBody>

                    <ModalFooter w={"full"} justifyContent={"center"}>
                        <Button
                            type="submit"
                            bgColor={'#5C1628'} borderRadius={"unset"}
                            _hover={{bgColor: '#5C1628'}}
                            color={'#FFFFFF'}
                            w="215px"
                            h={'50px'}
                            alignSelf={"center"}
                            isLoading={submitting}
                            isDisabled={!isFormValid}
                            gap={'10px'}
                        >
                            {t('ticket.save')}
                            <svg width="8" height="10" viewBox="0 0 8 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M0 0H3.58481L8 5L3.58481 10H0L4.43544 5L0 0Z" fill="white"/>
                            </svg>
                        </Button>
                    </ModalFooter>
                </form>
            </ModalContent>
        </Modal>
    );
};

export default RegistrationModal;
